import React from "react";
import { DiscountTier } from "../../../CheckoutPage/components/types";

interface DiscountTierPanelProps {
  tiers: DiscountTier[];
  className: string;
  badgeClassName: string;
  tiersClassName: string;
  highlightClassName?: string;
  title?: string;
  titleClassName?: string;
  children?: React.ReactNode;
}

const PRINTER_ICON = (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M6 9V2h12v7M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2M6 14h12v8H6v-8z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

function formatTier(tier: DiscountTier): string {
  return tier.kind === "percentage"
    ? `Buy ${tier.minQuantity} get ${tier.value}% off`
    : `Buy ${tier.minQuantity} for ${tier.value}`;
}

const DiscountTierPanel: React.FC<DiscountTierPanelProps> = ({
  tiers,
  className,
  badgeClassName,
  tiersClassName,
  highlightClassName,
  title,
  titleClassName,
  children
}) => {
  const tierText = [...tiers]
    .sort((a, b) => a.minQuantity - b.minQuantity)
    .map(formatTier)
    .join(", ");

  return (
    <div className={className}>
      <span className={badgeClassName}>
        {PRINTER_ICON}
        PRINT DISCOUNT
      </span>
      {title && <p className={titleClassName}>{title}</p>}
      <p className={tiersClassName}>
        {tierText}.{" "}
        <strong className={highlightClassName}>
          You can pick different photos for each product.
        </strong>
      </p>
      {children}
    </div>
  );
};

export default DiscountTierPanel;
